<template>
  <div>
    <el-col :span="24">
      <div>
        <SaleFavourEdit ref="DataContactEdit" @bindGrid="bindGrid" :forExternalDept="forExternalDept"></SaleFavourEdit>
        <SaleFavourEdit ref="SaleFavourEditChild" @bindGrid="bindGrid" :forExternalDept="forExternalDept"></SaleFavourEdit>
        <div class="search-content" v-if="!forExternalDept">
          <el-col :span="24" class="toobar">


            <el-col :span="3">
              <AutoCustomer @clear="clearCustomerName" :size="''" @handleSelect="afterSelExternalDept"></AutoCustomer>
            </el-col>
            <el-col :span="4">
              <!--<span class="demonstration">开始日期</span>-->
              <!--<el-date-picker style="width:120px"-->
                              <!--v-model="begindate" :value-format="'yyyy-MM-dd'"-->
                              <!--type="date"-->
                              <!--placeholder="选择日期">-->
              <!--</el-date-picker>-->
              <span class="demonstration">有效期</span>
              <el-date-picker style="width:140px"
                              v-model="enddate" :value-format="'yyyy-MM-dd'"
                              type="date"
                              placeholder="选择日期">
              </el-date-picker>
            </el-col>
            <el-col :span="3">
              <el-input v-model="title" auto-complete="off" placeholder="标题"></el-input>
            </el-col>
            <!--<el-col :span="2">-->
              <!--<el-select v-model="independentserial" placeholder="请选择">-->
                <!--<el-option key="1" label="全部" value="all">-->
                <!--</el-option>-->
                <!--<el-option-->
                  <!--v-for="item in this.idd"-->
                  <!--:key="item.serialnum"-->
                  <!--:label="item.dname"-->
                  <!--:value="item.serialnum">-->
                <!--</el-option>-->
              <!--</el-select>-->
            <!--</el-col>-->
            <!--<el-col :span="2">-->
              <!--<el-select v-model="couponway" placeholder="请选择优惠方式" clearable>-->
                <!--<el-option-->
                  <!--v-for="item in this.ruleArray"-->
                  <!--:key="item.value"-->
                  <!--:label="item.label"-->
                  <!--:value="item.value">-->
                <!--</el-option>-->
              <!--</el-select>-->
            <!--</el-col>-->
            <el-col :span="2">
              <el-select v-model="ruleCode" placeholder="优惠规则" clearable @change="changeType">
                <el-option
                  v-for="item in this.ruleData"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="4">
              <el-button type="primary" v-model="searchdata" icon="el-icon-search" @click="bindGrid">搜索</el-button>
              <el-button type="warning" v-on:click="add">新增</el-button>
              <el-button type="warning" v-on:click="loadDiscountExcel" v-if="ruleCode=='50'||ruleCode=='60'">导出</el-button>
            </el-col>
            <el-col :span="3">
              <el-button type="warning" v-if="userInfoModel&&userInfoModel.mobile=='15250395939'" :loading="importFileLoading" :disabled="importFileLoading" v-on:click="importList">EXCEL导入</el-button>
            </el-col>
            <SaleTypeEdit ref="DataContactLookEdit"></SaleTypeEdit>
            <SalecomboEdit ref="SalecomboEdit1"></SalecomboEdit>
            <ExternaldeptSel ref="externalsel" :unitgroup="1" :title="'选择客户'" @select="selectExternalDept"></ExternaldeptSel>
            <input type="file" ref="fileupload1" style="display:none;" @change="change1($event)"/>
          </el-col>
        </div>
        <el-table
          :data="tableData"
          :height="forExternalDept?null:tableHeight()"
          size="mini"
          stripe
          border
          style="width: 100%;">
          <el-table-column
            width="60"
            label="序号"
            align="center">
            <template slot-scope="scope">
              {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
            </template>
          </el-table-column>
          <el-table-column
            prop="title"
            label="标题"
            align="left"
            min-width="250"
            header-align="center"
            :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            align="center"
            label="有效开始日期" width="120">
            <template slot-scope="scope">
              {{(scope.row.begindate || "").substr(0, 10)}}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="有效结束日期" width="120">
            <template slot-scope="scope">
              {{(scope.row.enddate || "").substr(0, 10)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="deptname"
            label="客户"
            align="left"
            width="200"
            header-align="center"
            :show-overflow-tooltip="true" v-if="!forExternalDept">
            <template slot-scope="scope">
              {{(scope.row.deptname||"")+" "+(scope.row.customerserial||"")}}
            </template>
          </el-table-column>
          <!--<el-table-column-->
            <!--prop="couponway"-->
            <!--label="优惠方式"-->
            <!--align="left"-->
            <!--header-align="center"-->
            <!--width="120" v-if="!forExternalDept">-->
            <!--<template slot-scope="scope">-->
              <!--<div v-if="scope.row.couponway==100">下单时打折</div>-->
              <!--<div v-if="scope.row.couponway==200">注册后赠送</div>-->
              <!--<div v-if="scope.row.couponway==300">购买后使用</div>-->
            <!--</template>-->
          <!--</el-table-column>-->
          <el-table-column
            prop="rule"
            label="售价"
            align="left"
            header-align="center" v-if="!forExternalDept"
            width="120">
            <template slot-scope="scope">
              {{ getPrice(scope.row.couponrule)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="rule"
            label="优惠规则"
            align="left"
            header-align="center" :show-overflow-tooltip="true"
            width="100" v-if="!forExternalDept">
          </el-table-column>
          <el-table-column label="操作" align="left" width="220" fixed="right" v-if="!forExternalDept||CanEdit">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)">编辑
              </el-button>
              <!--<el-button-->
                <!--size="mini"-->
                <!--type="danger"-->
                <!--@click="handleDelete(scope.$index, scope.row)"-->
                <!--v-if="!(scope.row.customerserial&&scope.row.customerserial=='global template')&&!scope.row.contractguid">删除-->
              <!--</el-button>-->
              <el-button
                size="mini"
                v-show="scope.row.type!=50 && scope.row.type!=60"
                @click="handleLook(scope.$index, scope.row)"
                v-if="!(scope.row.customerserial&&scope.row.customerserial=='global template')">查看
              </el-button>
              <el-button
                size="mini"
                v-show="scope.row.type==50 || scope.row.type==60"
                @click="copyDiscount(scope.$index, scope.row)"
                v-if="!(scope.row.customerserial&&scope.row.customerserial=='global template')&&!forExternalDept&&!scope.row.contractguid">复制
              </el-button>
              <el-button size="mini" v-show="scope.row.type==10" @click="showAutomatic(scope.row)" >发放</el-button>
            </template>
          </el-table-column>
          <Automatic ref="Automatic1"></Automatic>
        </el-table>
        <div class="foot" v-if="!forExternalDept">
          <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
        </div>
      </div>
    </el-col>
  </div>
</template>
<script>
  import SaleFavourEdit from './SaleFavourEdit';
  import Automatic from './Automatic';
  import SaleTypeEdit from './SaleTypeEdit'
  import SalecomboEdit from './SalecomboEdit'
  import {getListData, deleteData, getFavourType, copyData,loadExcel,saveData} from '@/api/set/salefavour'
  import {getGoodsTree,list4PriceSet} from '@/api/set/jxcgooddetail';
  import {independentDept} from '@/api/set/dept';
  import ExternaldeptSel from '../externaldept/ExternaldeptSel';
  import {checkModuleRight} from '../../../api/login'

  export default {
    name: 'SaleFavourList',
    data() {
      return {
        msg: 'Welcome to Your Vue.js App',
        dialogFormVisible: false,
        temporaryRow: {},//临时对象
        searchdata: "",
        loading: true,
        independentserial: 'all',
        customerserial: "",
        idd: [],
        ruleArray: [{
          value: '100',
          label: '下单时打折'
        }, {
          value: '200',
          label: '注册后赠送'
        }, {
          value: '300',
          label: '购买后使用'
        }],
        begindate: '',
        title:'',
        enddate: '',
        couponway: '',
        pagination: {
          currentPage: 1,
          pageSize: 0,
          total: 0
        },
        tableData: [],
        controlData: {},
        ruleData: [],
        ruleCode: '',
        importFileLoading: false,//EXCEL导入处理中loading
        userInfoModel: null,//登录人信息用于EXCEL导入按钮权限
      }
    },
    props: {
      forExternalDept: {
        defalut: false//设置客户的时候启用
      },
      searchcustomerserial: {
        defalut: ""
      },
      CanEdit: {
        defalut: true
      }
    },
    methods: {
      //EXCEL导入固定价优惠券
      importList() {
        this.$refs.fileupload1.value = ""
        this.$refs.fileupload1.click()
      },
      change1(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！")
            return
          }
          this.$importExcel(event.target.files[0], (data) => {
            this.handleImportData(data)
          })
        } catch (ee) {
          this.$message.error("导入失败")
        }
      },
      //取单元格值，兼容二维数组和对象行(列头行解析)
      getCol(row, key, index) {
        var v;
        if (Array.isArray(row)) {
          v = row[index];
        } else {
          v = row[key];
          if (v == null)
            v = row[index];
        }
        return v;
      },
      //解析导入数据并按客户编码(customerserial)分组
      handleImportData(data) {
        if (!data || data.length == 0) {
          this.$message.error("导入文件为空！")
          return
        }
        var errList = [];//行解析错误列表
        var customerMap = {};//按客户编码分组,key=customerserial
        for (var i = 0; i < data.length; i++) {
          var row = data[i];
          if (!row || (typeof row == "object" && Object.keys(row).length == 0))
            continue;
          var cs = this.getCol(row, '客户编码', 0);
          var cn = this.getCol(row, '客户名称', 1);
          var sc = this.getCol(row, '商品编码', 2);
          var fm = this.getCol(row, '固定价', 3);
          cs = (cs == null) ? '' : String(cs).trim();
          cn = (cn == null) ? '' : String(cn).trim();
          sc = (sc == null) ? '' : String(sc).trim();
          fm = (fm == null) ? '' : String(fm).trim();
          //跳过全空行
          if (cs == '' && cn == '' && sc == '' && fm == '')
            continue;
          //四项缺任一
          if (cs == '' || cn == '' || sc == '' || fm == '') {
            errList.push('第' + (i + 1) + '行:缺少字段')
            continue;
          }
          var fixmoney = Number(fm);
          if (isNaN(fixmoney)) {
            errList.push('第' + (i + 1) + '行:固定价错误')
            continue;
          }
          if (!customerMap[cs]) {
            customerMap[cs] = {
              customerserial: cs,
              customername: cn,
              formp: []
            };
          }
          customerMap[cs].formp.push({
            categorycode: '',
            categoryname: '',
            costprice: null,
            discount: null,
            dismethod: '1',//1=固定价
            fixmoney: fixmoney,
            isskim: null,
            parentguid: null,
            seedcode: sc,
            seedname: '',
            tenantid: null,
            unitguid: null
          });
        }
        var customerSerials = Object.keys(customerMap);
        if (customerSerials.length == 0) {
          this.$message.error("没有可导入的有效数据！")
          return;
        }
        this.saveImportData(customerMap, errList);
      },
      //逐客户保存(串行):先list4PriceSet补全商品信息,再saveData保存
      async saveImportData(customerMap, errList) {
        this.importFileLoading = true;
        var customerSerials = Object.keys(customerMap);
        var success = 0;
        var failList = [];
        for (var i = 0; i < customerSerials.length; i++) {
          var item = customerMap[customerSerials[i]];
          //补全商品信息(接口可能因客户无门店信息报错,必须catch住,不能中断整个导入)
          var seedcodelist = '';
          for (var m = 0; m < item.formp.length; m++) {
            seedcodelist += item.formp[m].seedcode + ';';
          }
          try {
            var resp = await list4PriceSet({
              customguid: item.customerserial,
              seedcodelist: seedcodelist
            });
            var rows = resp.data.obj;
            if (rows && rows.length) {
              for (var p = 0; p < rows.length; p++) {
                for (var q = 0; q < item.formp.length; q++) {
                  if (rows[p].seedcode == item.formp[q].seedcode) {
                    if (rows[p].seedname != null)
                      item.formp[q].seedname = rows[p].seedname;
                    if (rows[p].categorycode != null)
                      item.formp[q].categorycode = rows[p].categorycode;
                    if (rows[p].categoryname != null)
                      item.formp[q].categoryname = rows[p].categoryname;
                    if (rows[p].costprice != null)
                      item.formp[q].costprice = rows[p].costprice;
                    else if (rows[p].prices && rows[p].prices.length > 0)
                      item.formp[q].costprice = rows[p].prices[0].costprice;
                  }
                }
              }
            }
          } catch (e) {
            console.log(e)
          }
          //构造form保存
          var now = new Date();
          var begindate = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0');
          var form = {
            unitguid: '',
            begindate: begindate,
            enddate: '2099-12-31',
            customerserial: item.customerserial,
            customername: item.customername,
            province: '',
            city: '',
            county: '',
            independentserial: '',
            pricelevel: '',
            couponway: '',
            duration: '0',
            couponnum: '0',
            title: '固定价导入-' + item.customername,
            describe: '',
            couponrule: JSON.stringify({type: '60'}),//60=按商品折扣(byseedcode)
            salefavouedetail: JSON.stringify(item.formp)
          };
          try {
            var res = await saveData(form);
            if (res.data.code == 0 || res.data.code == undefined) {
              success++;
            } else {
              failList.push(item.customerserial + ':' + (res.data.message || '保存失败'))
            }
          } catch (e) {
            console.log(e)
            failList.push(item.customerserial + ':保存失败')
          }
        }
        this.importFileLoading = false;
        this.bindGrid();
        var msg = '导入完成：成功 ' + success + ' 张，失败 ' + failList.length + ' 张';
        if (errList.length > 0) {
          msg += '，行错误：' + errList.slice(0, 3).join('；')
        }
        if (failList.length > 0) {
          msg += '，失败原因：' + failList.slice(0, 3).join('；')
        }
        this.$message({
          message: msg,
          type: (failList.length > 0 || errList.length > 0) ? 'warning' : 'success'
        });
      },
      showAutomatic(row) {
        this.$refs.Automatic1.initdata(row);
      },
      getPrice(rule){
        if(!rule)
          return '';
        var jsR=JSON.parse(rule);
        if(jsR.saleprice>=0&&jsR.money>=0){
          // if(jsR.money==jsR.saleprice){
          //   return jsR.money;
          // }else{
            return jsR.money+' -- '+jsR.saleprice;
          // }
        }
        return '';
      },
      clearCustomerName() {
        this.customerserial = "";
      },
      afterSelExternalDept(customerserial, deptname, row) {
        this.customerserial = customerserial;
        this.bindGrid()
      },
      //复制优惠券
      copyDiscount(index, row) {
        this.$refs.externalsel.show()
        this.temporaryRow = row
      },
      //选择客户的回调方法
      selectExternalDept(customerserial, deptname, row) {
        copyData({
          unitguid: this.temporaryRow.unitguid,
          customerserial: customerserial,
          deptname: deptname,
        }).then((response) => {
          if (response.data.code == 0) {
            this.$message({
              message: '复制成功',
              type: 'success'
            })
            this.bindGrid();
          }
        })

      },
      handleEdit(index, row) {
        this.$refs.DataContactEdit.initData(row.unitguid)
        this.OpenDialog()
      },
      changeType(){
        if(this.ruleCode=='50'||this.ruleCode=='60'){
          var now = new Date();
          this.enddate= now.getFullYear()+'-'+String(now.getMonth() + 1).padStart(2, '0')+'-'+String(now.getDate()).padStart(2, '0');
        }else{
          this.enddate='';
        }
        this.bindGrid();
      },
      loadDiscountExcel() {
        loadExcel({
          searchcustomerserial: this.customerserial,
          enddate: this.enddate,
          title: this.title,
          ruleCode: this.ruleCode
        }).then(response => {
          var rows = response.data.obj
          var date = new Date();
          var y = 1900 + date.getYear();
          var m = "0" + (date.getMonth() + 1);
          var d = "0" + date.getDate();
          if (this.ruleCode == '50') {
            let header1 = ["标题", "开始日期", "结束日期", "客户名称", "客户编码", "品牌编码", "品牌名称", "现片折扣", "定制折扣", "镜架折扣"]
            let column1 = ["title", "begindate", "enddate", "deptname", "customerserial", "categorycode", "categoryname", "value_10", "value_20", "value_80"]
            var name = '按品牌折扣' + y + m.substring(m.length - 2, m.length) + d.substring(d.length - 2, d.length)
            this.$exportExcel(header1, column1, rows, name)
          } else {
            let header1 = ["标题", "开始日期", "结束日期", "客户名称", "客户编码", "品牌编码", "品牌名称", "商品编码", "商品名称", "折扣方式","折扣","固定单价"]
            let column1 = ["title", "begindate", "enddate", "deptname", "customerserial", "categorycode", "categoryname", "seedcode", "seedname", "dismethod", "discount", "fixmoney"]
            var name = '按商品折扣' + y + m.substring(m.length - 2, m.length) + d.substring(d.length - 2, d.length)
            this.$exportExcel(header1, column1, rows, name)
          }
        }).catch((error) => {
        });
      },
      bindGrid(cusserial) {
        if (this.forExternalDept) {
          if (cusserial == null || cusserial == '')
            cusserial = this.searchcustomerserial;
          this.customerserial = cusserial;
          this.independentserial = 'all';
          this.pagination.currentPage = 1;
          this.pagination.pageSize = 100;
          this.ruleCode = 50;
          if (this.customerserial == '') {
            this.tableData.splice(0, this.tableData.length);
            return;
          }
        }
        getListData({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          searchcustomerserial: this.customerserial,
          independentserial: this.independentserial,
          begindate: this.begindate,
          enddate: this.enddate,
          title:this.title,
          couponway: this.couponway,
          ruleCode: this.ruleCode,
        }).then(response => {

          this.tableData = response.data.obj.rows
          this.pagination.total = response.data.obj.total
        }).catch((error) => {
          console.log(error)
        });
      },
      handleLook(index, row) {
        var obj = JSON.parse(row.couponrule);
        if (obj.type == 30) {
          this.$refs.DataContactLookEdit.show("加工券", row);
        } else if (obj.type == 40) {
          this.$refs.DataContactLookEdit.show("配送券", row);
        } else if (obj.type == 10) {
          this.$refs.DataContactLookEdit.show("满减券", row);
        } else if (obj.type == 20) {
          this.$refs.DataContactLookEdit.show("折扣券", row);
        } else if (obj.type == 70) {
          this.$refs.DataContactLookEdit.show("现金抵扣券", row);
        } else if (obj.type == 90) {
          this.$refs.SalecomboEdit1.show("销售套餐", row);
        } else if (obj.type == 80) {
          this.$refs.DataContactLookEdit.show("加急券", row);
        }
        if (obj.type == 90) {
          this.$refs.SalecomboEdit1.bindGrid(row.unitguid);
        } else {
          this.$refs.DataContactLookEdit.bindGrid(row.unitguid);
        }
      },
      add(customerserial, customername) {
        this.$refs.DataContactEdit.initForm()
        this.OpenDialog()
        if (this.forExternalDept) {
          this.$refs.DataContactEdit.selectExternalDept(customerserial, customername, null);
        }
      },
      OpenDialog() {
        this.$refs.DataContactEdit.show()
      }

    },
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      this.bindGrid();
      independentDept().then(response => {
        for (var i = 0; i < response.data.obj.length; i++) {
          this.idd.push(response.data.obj[i])
        }
      })
      getFavourType().then(response => {
        this.ruleData = response.data.obj
      })
    },
    components: {
      SaleFavourEdit,
      Automatic,
      SaleTypeEdit,
      SalecomboEdit,
      ExternaldeptSel
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .el-input--suffix .el-input__inner {
    padding-right: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/set/salefavour/SaleFavourList.vue